import type { MetricStripItem } from "../ui/MetricStrip";

export interface MarketingServerFixture {
  id: string;
  name: string;
  subspaces: number;
  ccu: string;
  ccuDelta: string;
  region: string;
  plan: string;
  uptime: string;
  tone: "cyan" | "violet";
  spark: readonly number[];
}

/**
 * Fictional data for the homepage's presentational dashboard preview. Never
 * reused on authenticated pages and never presented as live telemetry.
 */
export const marketingDashboardFixture: {
  servers: readonly MarketingServerFixture[];
  aggregate: readonly MetricStripItem[];
} = {
  servers: [
    {
      id: "srv_01h7x9z2",
      name: "Global Fabric",
      subspaces: 32,
      ccu: "8,642",
      ccuDelta: "12%",
      region: "Global",
      plan: "Scale",
      uptime: "99.99%",
      tone: "cyan",
      spark: [4, 6, 5, 7, 8, 7, 9, 8, 10, 9, 11, 10, 12],
    },
    {
      id: "srv_04k3l8m1",
      name: "Dark Forest",
      subspaces: 12,
      ccu: "2,731",
      ccuDelta: "8%",
      region: "NA East",
      plan: "Pro",
      uptime: "99.98%",
      tone: "violet",
      spark: [8, 7, 9, 6, 7, 8, 6, 7, 5, 6, 7, 6, 8],
    },
    {
      id: "srv_07n2p6q4",
      name: "Portfolio",
      subspaces: 6,
      ccu: "512",
      ccuDelta: "3%",
      region: "EU West",
      plan: "Pro",
      uptime: "99.97%",
      tone: "cyan",
      spark: [3, 4, 3, 5, 4, 6, 5, 6, 5, 7, 6, 7, 6],
    },
  ],
  aggregate: [
    { label: "Edge regions", value: "28", unit: "online" },
    { label: "Total CCU", value: "11,885", delta: { direction: "up", label: "11%" } },
    { label: "Data out", value: "1.2", unit: "TB", delta: { direction: "up", label: "9%" } },
    { label: "State ops", value: "2.7M", delta: { direction: "up", label: "6%" } },
    { label: "Inference calls", value: "340K", delta: { direction: "up", label: "14%" } },
  ],
};
